import {get, isString, keys, startCase, mapValues, map} from 'lodash'
import React from 'react'
import {bindActionCreators} from 'redux'
import {connect} from 'react-redux'

import * as Actions from '../redux/actions'

import { useClass, kvReplace } from '../lib/utils'

const kvReplaceToken = ['{', '}']
// var dependencyKey = ''

class Select extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      id: this.props.id,
      schema: this.props.schema,
      classes: get(this.props, 'schema.classes'),
      value: this.props.defaultValue || 'select',
      data: get(this.props, 'schema.data.fallback',
                [ {value: 'loading', text: 'Loading ...'}, ]
              ),
      dependency: `dependency.${get(this.props.schema, 'AXGKey', '')}`,
      updates: get(this.props, 'schema.updates', ''),
      required: get(this.props, 'schema.required', false),
    }
  }

  handleNavChange(e) {
    const component = this
    let value = e.target.getAttribute('data-value')
    let actions = e.target.getAttribute('data-actions')
    let storeActions = component.props.actions
    // console.info(`${this.props.AXGKey}/handleNavChange: value: ${value}`)
    // console.info(`${this.props.AXGKey}/handleNavChange: actions: ${actions}`)
    this.setState({
      value: value,
    })
    let storeKey = this.props.AXGKey
    this.props.actions.setAppxigonState({
      key: storeKey,
      value: value,
    })
    let otherKey = get(this.state.schema, 'set-value-to')
    if (otherKey) {
      this.props.actions.setAppxigonState({
          key: otherKey,
          value: value,
      })
    }
    // TODO: handle actions specified
    if (actions) {
      actions = JSON.parse(actions)
      if (actions.length) {
        actions.forEach(
          (action) => {
            if (Object.keys(action)[0] === 'modal') {
              let viewId = action['modal']
              let schema = get(component.props.appxigonSchema, `views.${viewId}`)
              // let schema = get(this.props.appxigonView, 'modalViewSchema')
              storeActions.setModalViewSchema({schema: schema})
            }
          }
        )
      }
    }
  }

  handleSelectChange(e) {
    var component = this
    var value = e.target.value
    var index = e.nativeEvent.target.selectedIndex
    var text = e.nativeEvent.target[index].text
    var storeKey = this.props.AXGKey // Default storeKey
    var localStoreKey = get(this.state.schema, 'store-key', null)
    // var text = e.target.text
    this.setState({
      value: value
    })
    // REVIEW: overwrite AXGKey if store-key is present
    // for mutually exclusive fields
    console.log(`store-key: ${localStoreKey}`)
    if (localStoreKey) {
      // replace last key. e.g. 'landing.info-and-options.size-house' => `landing.info-and-options.$(localStoreKey)`
      var l = storeKey.split('.')
      l.pop() // remove last element from array
      l.push(localStoreKey)
      storeKey = l.join('.')
    }
    console.info(`Redux Update: ${storeKey}`)
    this.props.actions.setAppxigonState({
      key   : [storeKey],
      value : value,
    })
    this.props.actions.setAppxigonState({
      key   : `${storeKey}.text`,
      value : text,
    })
    // updates dependency list
    // TODO: update other components to handle list of updates
    // current hack is for locale testing
    let updates = component.state.updates
    if (updates) {
      if (isString(updates)) {
        updates = [updates]
      }
      console.log(`Update dependency for: ${JSON.stringify(updates)}`)
      updates.forEach((u)=> {
        component.props.actions.setAppxigonState({
          key : `dependency.${u}`,
          // make it a string. value not important, just for redux value change detection
          value: JSON.stringify(value),
        })
      })
    }
  }

  componentWillMount() {
    this.refreshData()
  }

  refreshData() {
    // TODO: handle data direct source URL from component
    var component = this
    var schema = component.state.schema
    var dataSourceDef = get(schema, 'data.source') // e.g. 'ref.users' => 'data.ref.users'
    // console.log(dataSourceDef);
    var refDataSource = get(component.props.AXGDataSource, `${dataSourceDef}.source`, null)
    var refDataTransform = get(component.props.AXGDataSource, `${dataSourceDef}.transform`, null)
    var refDataFallback = get(component.props.AXGDataSource, `${dataSourceDef}.fallback`, null)
    // console.log(refDataSource);
    // console.log(refDataTransform);
    if (refDataSource) {
      var data = []
      // var dataTransform = refDataDef.transform
      // REVIEW: more generic way to handle GET variables transform
      var endpoint = refDataSource.endpoint
      var endpointTransform = get(refDataSource, 'transform')
      if (endpointTransform) {
        let keyMap = endpointTransform
        let keyMapTransformed =
          mapValues(
            keyMap,
            (val)=> {
              return get(component.props, ['input', `${val}`])
            }
          )
        console.log(`keyMap: ${JSON.stringify(keyMap)}`)
        console.log(`keyMapTransformed: ${JSON.stringify(keyMapTransformed)}`)
        endpoint = kvReplace(
          endpoint,
          keyMapTransformed,
          kvReplaceToken
        )
      }
      console.info(`AJAX endpoint: ${JSON.stringify(endpoint)}`)
      $.ajax({
        url: endpoint,
        method: 'GET'
      }).then(function(rawData) {
        // console.log(`rawData: ${JSON.stringify(rawData)}`)
        if (refDataTransform) {
          var keyMap = refDataTransform
          data = map(rawData, (item, key) =>
            mapValues(keyMap, (val)=>
              keys(item).includes(val)
                ? item[val]
                : kvReplace(val, item, kvReplaceToken)
            )
          )
          // console.log(`transformed data: ${JSON.stringify(data)}`)
        } else {
          data = rawData
        }
        component.setState({
          data  : data
        })
      })
      // TODO: handle ajax call failure
      // this.setState({
      //   data  : [ { value: 'error', text: 'Unable to load data ...' } ],
      // })
    } else {
      // handle direct source link from within item
      if (refDataFallback) {
        component.setState({
          data  : refDataFallback,
        })
      }
    }
    // Set current or default value
    var storeKey = component.props.AXGKey // default storeKey
    var localStoreKey = get(component.state.schema, 'store-key', null)
    if (localStoreKey) {
      var l = storeKey.split('.')
      l.pop() // remove last element from array
      l.push(localStoreKey)
      storeKey = l.join('.')
    }
  }

  componentWillReceiveProps(nextProps) {
    var component = this
    // REVIEW: is this a proper way ? Will this trigger unnecessary update?
    var dependencyKey = `dependency.${this.props.AXGKey}`
    var nextDepencyValue = get(nextProps.appxigonState, dependencyKey, '')
    if (component.state.dependency != nextDepencyValue) {
      console.info(`select: (${component.state.id}) dependency changed: refreshData`)
      component.refreshData()
    }
    component.setState({
      dependency: nextDepencyValue,
    })
  }

  render() {
    let component = this
    let id = `select-${this.state.id}`
    let schema = component.state.schema
    let variant = get(schema, 'variant')
    let title = get(schema, 'title', startCase(this.state.id))
    let icon = get(schema, 'icon')
    let defaultValue = get(component.props, 'schema.data.default')
    let data = defaultValue ? component.state.data : [{value:'', text: '. . . . . . . . . .'}].concat(component.state.data)
    let isRequired = component.state.required

    // console.info(`${component.props.AXGKey}: value: ${component.state.value}`)
    const defaultSubType =
      <div className={`${component.state.classes}${component.props.show ? '' : ' hidden'}`}>
        <div className='input-group'>
          {
            icon &&
            <span className="input-group-addon">
              <i className="material-icons">{ icon }</i>
            </span>
          }
          { <label htmlFor={id}>{title}</label> }
          <select
            id={id}
            className='form-control'
            value={component.state.value}
            onChange={component.handleSelectChange.bind(this)}>
            {
              data.map(
                (i) => <option key={i.value} value={i.value}>{i.text}</option>
              )
            }
          </select>
          {
            isRequired &&
            <span class="input-group-addon">*</span>
          }
        </div>
      </div>

    const navType =
      <div className={useClass(
          component.state.classes,
          {'hidden': !component.props.show}
        )}
      >
        <ul className="nav nav-pills">
          {
            data.map((i) =>  {
                    // FIXME: define icon type by prefix. e.g. 'fa-...' use fa icons
                    let iconLeft = get(i, 'icon-left')
                    return <li
                          key={i.value}
                          role="presentation"
                          data-value={i.value}
                          className={useClass(
                              'clickable',
                              {active: component.state.value == i.value}
                            )
                          }
                        >
                          <a
                            data-value={i.value}
                            data-actions={JSON.stringify(get(i, 'actions'))}
                            onClick={component.handleNavChange.bind(this)}
                            >
                              { iconLeft && <i className={`fa fa-icon ${iconLeft}`} /> }
                              { iconLeft && <span>&nbsp;&nbsp;</span> }
                              {_t(i.text)}
                          </a>
                        </li>
                    }
            )
          }
        </ul>
      </div>

    return (
      variant
        ? navType
        : defaultSubType
    )
  }
}

function mapStateToProps(state) {
  return {
    appxigonState: state.AXGState,
    appxigonSchema: state.AXGSchema.schema,
  }
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Select)



// WEBPACK FOOTER //
// ./item-types/select.js